import { CaretRightIcon } from '@phosphor-icons/react/dist/ssr'
import { useRefinementList } from 'react-instantsearch'

import { FACET_LABELS } from './CollectionFiltersDrawer'

export const FacetItem = ({ facet, onClick }: { facet: string; onClick: () => void }) => {
  const { items } = useRefinementList({ attribute: facet })
  const selectedItems = items.filter((item) => item.isRefined)
  if (!items.length) return null

  return (
    <li className="flex cursor-pointer flex-col justify-between border-b border-grey-200 py-5 text-base font-medium capitalize first:pt-6" onClick={onClick}>
      <div className="flex items-center justify-between">
        {FACET_LABELS[facet as keyof typeof FACET_LABELS] ?? facet}
        <CaretRightIcon weight="bold" size={16} className="text-grey-500" />
      </div>

      <div className="no-scrollbar flex gap-1 overflow-scroll">
        {selectedItems?.map((item, index) => (
          <div key={item.value} className="flex whitespace-nowrap text-base font-normal text-neutral-700">
            <div>{item.label}</div>
            {index !== selectedItems.length - 1 ? ', ' : ''}
          </div>
        ))}
      </div>
    </li>
  )
}
